export const RESET = 'VIDEO_UPDATE_RESET';
export const SET_ERROR = 'VIDEO_UPDATE_SET_ERROR';
export const SET_RETRIEVED = 'VIDEO_UPDATE_SET_RETRIEVED';
export const SET_UPDATED = 'VIDEO_UPDATE_SET_UPDATED';
export const SET_VIOLATIONS = 'VIDEO_UPDATE_SET_VIOLATIONS';
export const TOGGLE_LOADING = 'VIDEO_UPDATE_TOGGLE_LOADING';
export const UPDATE_RETRIEVED = 'VIDEO_UPDATE_UPDATE_RETRIEVED';



// WEBPACK FOOTER //
// ./src/store/modules/video/update/mutation_types.js